import { useState } from 'react';
import { setPassword } from '../../../store/slices/auth';
import { useAppDispatch } from '../../../store/store';
import { useNavigate } from 'react-router-dom';
import styles from './SetYourNewPassword.module.scss';

import Input from '../../../components/UI/Inputs/Input';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../hooks/useTranslations';

function SetYourNewPassword() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { translations } = useTranslation();
  const [passwords, setPasswords] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleNext = async () => {
    await dispatch(setPassword({ password: passwords }));
    const error = localStorage.getItem('set-password-error');

    if (error === '200') {
      navigate('/web/password-reset-confirmed');
    } else {
      toast.error('Something went wrong', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  const setClassName = (rgx: boolean) => {
    if (passwords === '') return undefined;
    if (rgx) return styles.valid;
    else return styles.invalid;
  };
  const passCheck = () => {
    return (
      (/[a-z]/.test(passwords) || /[A-Z]/.test(passwords)) &&
      /[!@#$%^&*)(}{.,_=|:;-]/.test(passwords) &&
      /\d/.test(passwords) &&
      passwords.length >= 6
    );
  };
  return (
    <div className={styles.container}>
      <div className={styles.setNewPasswordContent}>
        <div className={styles.title}>{translations('label.create_new_password')}</div>
        <span className={styles.textHint}>{translations('label.your_new_password_must_be')}</span>

        <div className={styles.passwordInputs}>
          <Input
            label={translations('label.new_password')}
            type="password"
            onChange={(e) => setPasswords(e.target.value)}
            value={passwords}
            placeholder={translations('label.new_password')}
            id={'new_password'}
            isSecure={false}
            textarea={false}
            errorText={''}
          />
          <Input
            label={translations('label.confirm_new_password')}
            type="password"
            onChange={(e) => setConfirmPassword(e.target.value)}
            value={confirmPassword}
            placeholder={translations('label.confirm_new_password')}
            id={'new_password'}
            isSecure={false}
            textarea={false}
            errorText={''}
          />
        </div>
        <p className={styles.helperTitle}>{translations('label.min_requirements')}</p>
        <ul className={styles.helperText}>
          <li
            className={setClassName(
              passwords.length >= 6 && (/[a-z]/.test(passwords) || /[A-Z]/.test(passwords))
            )}
          >
            {translations('label.6_characters')}
            <span />
          </li>
          <li className={setClassName(/\d/.test(passwords))}>
            {translations('label.at_least_one_number')}
            <span />
          </li>
          <li className={setClassName(/[!@#$%^&*)(}{.,_=|:;-]/.test(passwords))}>
            {`${translations('label.special_char')} (!@#$%^&*(){}.,_=|:;-)`}
            <span />
          </li>
        </ul>
        <div className={styles.button}>
          <PrimaryButtonV2
            text={translations('action.confirm')}
            containerStyle={{
              width: '100%',
            }}
            buttonStyle={{
              width: '100%',
            }}
            disabled={!(passCheck() && passwords === confirmPassword)}
            onClick={handleNext}
          />
        </div>
      </div>
    </div>
  );
}

export default SetYourNewPassword;
